import { DomainConfig } from './config.model';

export default class ConfigService {
    constructor() {
        //
    }

}